import { PLATFORMS } from '../../config';

export const isDesktopOnlyTargeted = platformTargeting =>
    platformTargeting?.length === 1 && platformTargeting?.[0] === PLATFORMS.DESKTOP;
